export default __webpack_public_path__ + "static/media/cg_perspective.9c8577d6.jpg";